import { useState } from 'react';

import cn from 'classnames/bind';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Popup, PopupContent, Button } from 'ui';
import SearchPageForm from 'ui/layouts/SearchPageForm';

import s from './SearchPopup.module.scss';

const cx = cn.bind(s);

const SearchPopup = ({
  isOpen,
  onClose,
  hasSuggestions = true,
  className,
  ...attrs
}) => {
  const [search, setSearch] = useState('');
  const handleSearchChange = (searchValue) => {
    setSearch(searchValue);
  };
  const handleClose = () => {
    setSearch('');
    onClose();
  };
  return (
    <Popup isOpen={isOpen} {...attrs} onClose={handleClose}>
      <PopupContent title="Looking for something?" onClose={handleClose}>
        <SearchPageForm initialSearch={search} onChange={handleSearchChange}>
          {({ isLoading }) => (
            <>
              {hasSuggestions && (
                <>
                  <h4 className={cx('categoriesTitle', 'tp-header-4')}>
                    Most popular topics
                  </h4>
                  <div className={cx('table')}>
                    <ul className={cx('tableCol')}>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/beginners" className={cx('categoryLink')}>
                          Beginners
                        </Link>
                      </li>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/romance" className={cx('categoryLink')}>
                         Romance
                        </Link>
                      </li>
                    </ul>
                    <ul className={cx('tableCol')}>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/core theory" className={cx('categoryLink')}>
                          Core theory
                        </Link>
                      </li>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/a little fun" className={cx('categoryLink')}>
                          A little fun
                        </Link>
                      </li>
                    </ul>
                    <ul className={cx('tableCol')}>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/personal growth" className={cx('categoryLink')}>
                          Personal growth
                        </Link>
                      </li>
                      <li className={cx('categoryItem')}>
                        <Link href="/search/everyday life" className={cx('categoryLink')}>
                          Everyday life
                        </Link>
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <div className={cx('actionRow')}>
                <Button disabled={isLoading}>Search</Button>
              </div>
            </>
          )}
        </SearchPageForm>
      </PopupContent>
    </Popup>
  );
};

SearchPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default SearchPopup;
